import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPercent = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.8335 4.16659L4.16683 15.8333M7.50016 5.41659C7.50016 6.56718 6.56742 7.49992 5.41683 7.49992C4.26624 7.49992 3.3335 6.56718 3.3335 5.41659C3.3335 4.26599 4.26624 3.33325 5.41683 3.33325C6.56742 3.33325 7.50016 4.26599 7.50016 5.41659ZM16.6668 14.5833C16.6668 15.7338 15.7341 16.6666 14.5835 16.6666C13.4329 16.6666 12.5002 15.7338 12.5002 14.5833C12.5002 13.4327 13.4329 12.4999 14.5835 12.4999C15.7341 12.4999 16.6668 13.4327 16.6668 14.5833Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPercent;
